import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 12 June 2025</p>
      <p>At SmileGuide, we respect your privacy and are committed to protecting your personal data.</p>
      <h3>1. Information Collected</h3>
      <ul>
        <li>Name, email, phone number</li>
        <li>Payment information (processed securely via third-party gateways)</li>
        <li>Usage and interaction data to improve course experience</li>
      </ul>
      <h3>2. How We Use Your Information</h3>
      <ul>
        <li>To deliver course content</li>
        <li>To communicate important updates</li>
        <li>To improve our services</li>
      </ul>
      <h3>3. Data Security</h3>
      <p>We implement standard security measures to protect your data. However, no digital transmission or storage is 100% secure.</p>
      <h3>4. Third-party Disclosure</h3>
      <p>We do not sell, trade, or otherwise transfer your personal information to outside parties, except trusted service providers assisting in operating our site and services.</p>
    </div>
  );
};

export default PrivacyPolicy;
